export const metaMixin = {
	data() {
		return {
			meta: {
				statusses: [],
				default_priority: 0
			},
			org_task_status_id: 0,
			filter_status_types: [2, 3],
			loading_meta: false,
		}
	},
	computed: {
		filtered_task_statusses: function() {
			let filtered = [];

			if (this.meta.statusses) {
				let self = this;

				this.meta.statusses.forEach(function(this_status) {
					if (this_status.id == self.org_task_status_id) {
						filtered.push(this_status);
					} else if (this_status.isactive && self.filter_status_types.includes(this_status.type)) {
						filtered.push(this_status);					
					}
				});

				filtered.sort(function(a, b) {
					if (a.type < b.type) {
						return -1;
					} else if (a.type > b.type) {
						return 1;
					} else if (a.desc < b.desc) {
						return -1;
					} else if (a.desc > b.desc) {
						return 1;
					} else {
						return 0;
					}
				});
			};

			return filtered;
		}	},
	methods:{
		load_meta_data() {
			let self = this; // make sure we can access this inside of our promisses
			this.loading_meta = true;

			axios
				.get("/api/tasks/meta", {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						self.meta = json.meta;
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				})
				.finally(function() {
					self.loading_meta = false;
				});	
		},
	}
}